var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0.25H12.75V10L7.5 15.25L6.5625 14.3125C6.475 14.225 6.40313 14.1063 6.34688 13.9563C6.29063 13.8063 6.2625 13.6625 6.2625 13.525V13.2625L7.0875 10H2.25C1.85 10 1.5 9.85 1.2 9.55C0.9 9.25 0.75 8.9 0.75 8.5V7C0.75 6.9125 0.7625 6.81875 0.7875 6.71875C0.8125 6.61875 0.8375 6.525 0.8625 6.4375L3.1125 1.15C3.225 0.9 3.4125 0.6875 3.675 0.5125C3.9375 0.3375 4.2125 0.25 4.5 0.25ZM11.25 1.75H4.5L2.25 7V8.5H9L7.9875 12.625L11.25 9.3625V1.75ZM12.75 10V8.5H15V1.75H12.75V0.25H16.5V10H12.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default __webpack_public_path__ + "static/media/thumb_down.e5482a6547ecc0544e34565f19ed50fc.svg";
export { ForwardRef as ReactComponent };